//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class DiscountService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Discount.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/discount/create', params || { });
	};

	//GeneratorFlag:[Discount.Delete]
	async delete(discountId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:discountId
		}
	
		return await _server.delete('/store/discount/delete', {'params':params})
	};

	//GeneratorFlag:[Discount.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/discount/detail', {'params':params});
	};

	//GeneratorFlag:[Discount.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/discount/list', {'params':params});
	};

	//GeneratorFlag:[Discount.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/discount/update', params || { });
	};

//GeneratorFlag:[NewAction]
}